// static/table_engine_src/global/inactive.js
"use strict";

import { getActiveEngine } from "../core/esc_global.js";

export function installGlobalTableInactiveClass() {
  if (window.__mbbGlobalTableInactiveInstalled) return;
  window.__mbbGlobalTableInactiveInstalled = true;

  const TABLE_UI_SEL = [
    ".table-scroll",
    "table",
    ".te-popover",
    ".te-context-menu",
    ".te-menu",
    ".te-dropdown",
    ".floating-mini-toolbar",
    ".ab-tooltip",
  ].join(",");

  function inTableUI(el) {
    return !!el?.closest?.(TABLE_UI_SEL);
  }

  function setInactive(v) {
    // Always allow turning inactive OFF immediately
    if (!v) {
      try {
        document.body.classList.remove("te-inactive");
      } catch {}
      return;
    }

    // Turning inactive ON must be guarded, otherwise ESC blur kills highlight.
    const a = getActiveEngine();
    const ae = document.activeElement;

    // If we have an active engine and focus is inside its table, do NOT go inactive.
    // (This includes the table itself being focused.)
    const table = a?.table || null;
    const focusInsideTable = !!(table && ae && (ae === table || table.contains(ae)));

    // If selection/menu exists, it's also not "inactive".
    const hasAnything = typeof a?.hasAnything === "function" ? !!a.hasAnything() : false;

    if (focusInsideTable || hasAnything) return;

    try {
      document.body.classList.add("te-inactive");
    } catch {}
  }

  document.addEventListener(
    "pointerdown",
    (e) => setInactive(!inTableUI(e.target)),
    true
  );

  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key === "Escape") setInactive(true);
    },
    true
  );
}